module.exports = __webpack_public_path__ + "img/play.13eadcac.svg";